import { combineEpics } from "redux-observable";

import companiesMainEpic from "./companyMain/companyMain.epic";
import companyEpic from "./company/company.epic";
import productEpic from "modules/companies/product/store/product.epic";

const companiesEpic = combineEpics(companiesMainEpic, companyEpic, productEpic);

export default companiesEpic;
